module.exports = __webpack_public_path__ + "img/slot.c9c64bac.png";